import { TConfig } from 'lib/common/types/Config';

export default function getInstanceUrl(config: TConfig) {
  const instanceAlias = config.CONNECT_HOST.split('.')[0].split('/')[2];
  const instanceUrl = `https://${instanceAlias}.my.connect.aws`;

  return instanceUrl;
}
